var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-switch"},[_c('el-switch',{attrs:{"value":_vm.on,"disabled":_vm.disabled},on:{"change":_vm.onChange}}),_c('span',{staticClass:"setting-switch__state",class:{ 'is-on': _vm.on }},[_vm._v(" "+_vm._s(_vm.on ? _vm.$t("common.on") : _vm.$t("common.off"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }